import React from 'react';

import { Help } from '../components/Help/Help';
import { useTranslations } from '../components/Translations/TranslationsProvider';

export const HelpPage = () => {
    const { translations } = useTranslations();

    if (!translations) {
        return null;
    }

    return <Help translations={translations} />;
};
